type DayProps = {
  children: React.ReactNode;
  withHours?: boolean;
};

const Day: React.FC<DayProps> = ({ children, withHours = false }) => {
  let options: Intl.DateTimeFormatOptions = {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  };
  if (withHours) {
    options = {
      ...options,
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
    };
  }
  return (
    <span>{new Date(children as any).toLocaleString(undefined, options)}</span>
  );
};

export default Day;
